import React from 'react';
import classNames from 'classnames';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h2 className="mt-2" style={{align: 'center'}}>
          <img
            src={require('./../../../assets/images/admin.jpg')}
            alt="Open"
            style={{height: "50px",width: "50px", verticalAlign: "middle", textAlign: "center"}}
            />
      </h2>
    </div>
  );
}

export default Logo;